import { render, staticRenderFns } from "./LegamDataTables.vue?vue&type=template&id=60203dd8&scoped=true&"
import script from "./LegamDataTables.vue?vue&type=script&lang=js&"
export * from "./LegamDataTables.vue?vue&type=script&lang=js&"
import style0 from "./LegamDataTables.vue?vue&type=style&index=0&id=60203dd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60203dd8",
  null
  
)

export default component.exports